module.exports = __webpack_public_path__ + "img/make_wish_btn.d815a5e4.png";